<div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
  <button mat-raised-button color="accent" (click)="irPaso(0)">
    <mat-icon class="mr-20">arrow_back</mat-icon>
    {{'SHEDULE2_0.BACK' | translate}}
  </button>
  <!-- <button mat-raised-button color="accent" (click)="irPaso(2)">
    <mat-icon class="mr-20">arrow_back</mat-icon>
    editar
  </button> -->
</div>

<div fxLayout="row wrap" fxLayoutAlign="space-evenly start" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
  <ng-container *ngFor="let correo of tipoCorreos; let i = index;">
    <div *ngIf="correo.activo" class="course-content m-20" fxLayout="column" fxFlex="100" fxFlex.gt-xs="40" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
      <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
        <div class="category" fxFlex>
          {{correo.titulo | translate}}
        </div>
      </div>
      <div class="content m-20" fxLayout="column" fxLayoutAlign="center center" fxFlex="1 1 auto">

        <ng-container *ngIf="i == 0">
          <p>{{'SHEDULE2_0.CORREOS.TIPO1.INFO' | translate}}</p>
          <mat-list>
            <mat-list-item>
              <p class="fz14 mr-20">{{'SHEDULE2_0.CORREOS.TIPO1.TIPO_1' | translate}}</p>
              <button mat-mini-fab color="accent" matTooltip="Ver mensaje" matTooltipPosition="right" (click)="irPaso(2,correo.tipo1)">
                <mat-icon>search</mat-icon>
              </button>
              <mat-divider></mat-divider>
            </mat-list-item>
            <mat-list-item>
              <p class="fz14 mr-20">{{'SHEDULE2_0.CORREOS.TIPO1.TIPO_2' | translate}}</p>
              <button mat-mini-fab color="accent" matTooltip="Ver mensaje" matTooltipPosition="right" (click)="irPaso(2,correo.tipo2)">
                <mat-icon>search</mat-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </ng-container>

        <ng-container *ngIf="i == 1">
          <p>{{'SHEDULE2_0.CORREOS.TIPO2.INFO' | translate}}</p>
          <button mat-raised-button color="accent" (click)="irPaso(2,correo.tipo)">
            {{'SHEDULE2_0.CORREOS.VER' | translate}}
            <mat-icon class="ml-20">search</mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="i == 2">
          <p>{{'SHEDULE2_0.CORREOS.TIPO3.INFO' | translate}}</p>
          <button mat-raised-button color="accent" class="wsn" (click)="irPaso(2,correo.tipo)">
            {{'SHEDULE2_0.CORREOS.VER' | translate}}
            <mat-icon class="ml-20">search</mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="i == 3">
          <p>{{'SHEDULE2_0.CORREOS.TIPO6.INFO' | translate}}</p>
          <button mat-raised-button color="accent" class="wsn" (click)="irPaso(2,correo.tipo)">
            {{'SHEDULE2_0.CORREOS.VER' | translate}}
            <mat-icon class="ml-20">search</mat-icon>
          </button>
        </ng-container>

      </div>
      <!-- <div class="footer" fxLayout="row" fxLayoutAlign="space-between center">
        <ng-container *ngIf="correo.completo == false">
          <div class="h4 secondary-text"><b>Aún no completo</b></div>
          <div class="roundEdg undone mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-icon class="s-20">priority_high</mat-icon>
          </div>
        </ng-container>
        <ng-container *ngIf="correo.completo == true">
          <div class="h4 secondary-text"><b>Listo</b></div>
          <div class="roundEdg done mat-elevation-z4 p-5 m-10" fxLayout="row" fxLayoutAlign="space-between center">
            <mat-icon class="s-20">done</mat-icon>
          </div>
        </ng-container>
        <ng-container *ngIf="correo.opcional == true">
          <div class="h4 secondary-text"><b>Este paso es opcional</b></div>
        </ng-container>
      </div> -->
    </div>
  </ng-container>
</div>
